import { render, staticRenderFns } from "./TaskViewPriorityDispatcher.vue?vue&type=template&id=58540f7c&scoped=true&lang=pug&"
import script from "./TaskViewPriorityDispatcher.vue?vue&type=script&lang=js&"
export * from "./TaskViewPriorityDispatcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58540f7c",
  null
  
)

export default component.exports